import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Ursus Victor LLC</title>
        <meta name="description" content="Privacy Policy for Ursus Victor LLC. Learn how we collect, use, and protect your personal information." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            Privacy Policy
          </h1>
          <p style={{fontSize: '1.1rem', opacity: 0.95}}>
            Last Updated: December 4, 2024
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              1. Introduction
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Ursus Victor LLC ("we," "our," or "us") respects your privacy and is committed to protecting 
              your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard 
              your information when you visit our website or use our loan application support and documentation services.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              2. Information We Collect
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              We collect information that you provide directly to us, including:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Personal identification information (name, email address, phone number)</li>
              <li>Business information (business name, industry, revenue)</li>
              <li>Financial information necessary for consultation services</li>
              <li>Communication preferences and consent records</li>
              <li>Any other information you choose to provide</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              3. How We Use Your Information
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              We use the information we collect to:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Provide, maintain, and improve our loan application support services</li>
              <li>Process and respond to your inquiries and support requests</li>
              <li>Send you information about our services, updates, and promotional materials</li>
              <li>Connect you with appropriate financial institutions and lenders</li>
              <li>Comply with legal obligations and protect our legal rights</li>
              <li>Detect, prevent, and address fraud or security issues</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              4. Information Sharing and Disclosure
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              We may share your information with:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li><strong>Financial Institutions:</strong> We share your information with verified lenders and financial 
              institutions to facilitate funding opportunities</li>
              <li><strong>Service Providers:</strong> Third-party vendors who perform services on our behalf</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with any merger, sale, or transfer of our business</li>
            </ul>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginTop: '1rem'}}>
              We do not sell your personal information to third parties.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              5. Data Security
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We implement appropriate technical and organizational security measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over 
              the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              6. Your Rights and Choices
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              You have the right to:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Access and receive a copy of your personal information</li>
              <li>Correct inaccurate or incomplete information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt out of marketing communications</li>
              <li>Withdraw consent for SMS communications by replying STOP</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              7. Cookies and Tracking Technologies
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We use cookies and similar tracking technologies to track activity on our website and hold certain information. 
              You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              8. Third-Party Links
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Our website may contain links to third-party websites. We are not responsible for the privacy practices 
              or content of these third-party sites. We encourage you to review their privacy policies.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              9. Data Retention
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              We retain your personal information for as long as necessary to provide our services and fulfill the purposes 
              outlined in this Privacy Policy. Specific retention periods include:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li><strong>Contact Information:</strong> Retained for 7 years after your last interaction with us</li>
              <li><strong>Application Support Records:</strong> Retained for 7 years for record-keeping and legal compliance</li>
              <li><strong>SMS Consent Records:</strong> Retained for 4 years after opt-out for TCPA compliance</li>
              <li><strong>Communication History:</strong> Retained for 3 years for quality assurance</li>
              <li><strong>Marketing Data:</strong> Retained until you opt out or request deletion</li>
            </ul>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginTop: '1rem'}}>
              You may request deletion of your data at any time by contacting support@ursusconnects.com, subject to 
              our legal obligations to retain certain records.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              10. SMS and Text Message Data
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              When you opt in to receive SMS communications from us:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>We collect and store your mobile phone number</li>
              <li>We record your consent timestamp and method</li>
              <li>We track message delivery status and opt-out requests</li>
              <li>We may use third-party SMS service providers (e.g., Twilio) to deliver messages</li>
              <li>Your phone number is never sold or shared for third-party marketing</li>
              <li>You can opt out at any time by replying STOP to any message</li>
            </ul>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginTop: '1rem'}}>
              Message and data rates may apply based on your mobile carrier plan. Standard carrier charges apply.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              11. California Privacy Rights (CCPA)
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              If you are a California resident, you have specific rights under the California Consumer Privacy Act (CCPA):
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li><strong>Right to Know:</strong> Request disclosure of personal information we collect, use, and share</li>
              <li><strong>Right to Delete:</strong> Request deletion of your personal information</li>
              <li><strong>Right to Opt-Out:</strong> Opt out of sale of personal information (we do not sell personal information)</li>
              <li><strong>Right to Non-Discrimination:</strong> Not to be discriminated against for exercising your rights</li>
            </ul>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginTop: '1rem'}}>
              To exercise these rights, email us at support@ursusconnects.com with "California Privacy Request" in the subject line.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              12. State-Specific Privacy Rights
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Residents of certain states including Virginia (VCDPA), Colorado (CPA), Connecticut (CTDPA), and Utah (UCPA) 
              have additional privacy rights. These may include rights to access, correct, delete, and opt out of certain 
              data processing activities. Contact us at support@ursusconnects.com to exercise these rights.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              13. Children's Privacy
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal 
              information from children under 18. If you become aware that a child has provided us with personal information, 
              please contact us immediately. You must be at least 18 years old to use our services or submit information 
              through our website.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              14. International Data Transfers
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Your information may be transferred to and processed in the United States or other countries where we or our 
              service providers operate. These countries may have data protection laws different from your country. By using 
              our services, you consent to the transfer of your information to these locations.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              15. Do Not Track Signals
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Some web browsers provide a "Do Not Track" (DNT) signal. Our website currently does not respond to DNT signals. 
              You can manage cookies and tracking through your browser settings.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              16. Changes to This Privacy Policy
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new 
              Privacy Policy on this page and updating the "Last Updated" date. For material changes, we may also notify 
              you via email or SMS. You are advised to review this Privacy Policy periodically for any changes. Continued 
              use of our services after changes constitutes acceptance of the updated policy.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              17. Contact Us
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              If you have any questions about this Privacy Policy, please contact us:
            </p>
            <div style={{
              background: '#dbeafe',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6'
            }}>
              <p style={{fontSize: '1rem', color: '#1e40af', marginBottom: '0.5rem'}}>
                <strong>Ursus Victor LLC</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#1e40af', marginBottom: '0.5rem'}}>
                Support: <a href="mailto:support@ursusconnects.com" style={{color: '#3b82f6'}}>support@ursusconnects.com</a>
              </p>
              <p style={{fontSize: '1rem', color: '#1e40af'}}>
                General Contact: <a href="mailto:info@ursusconnects.com" style={{color: '#3b82f6'}}>info@ursusconnects.com</a>
              </p>
            </div>
          </div>

          <div style={{
            background: '#fef3c7',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #f59e0b',
            textAlign: 'center'
          }}>
            <p style={{fontSize: '1rem', color: '#78350f', lineHeight: '1.7'}}>
              <strong>Your privacy is important to us.</strong> We are committed to protecting your personal information 
              and being transparent about our data practices.
            </p>
          </div>

          <div style={{marginTop: '3rem', textAlign: 'center'}}>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.1rem',
              display: 'inline-block'
            }}>
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy;
